import {NativeDateAdapter} from '@angular/material/core';
import momentLib from 'moment/moment';
import {Injectable} from '@angular/core';

@Injectable()
export class MaterialDateAdapter extends NativeDateAdapter {
  public parse(value: any): Date | null {
    if (!value) {
      return null;
    }
    if (value.indexOf('.') > -1) {
      const str = value.split('.');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const day = Number(str[0]);

      if (!(year >= 1000) || !day || !Number(str[1])) {
        return null;
      }

      const momentDate = momentLib(value, ['L', 'l'], true);
      if (momentDate.isValid()) {
        return new Date(year, month, day);
      }
      return null;
    } else if (this._isDateOfLength8(value)) {
      const momentDate = momentLib(value, ['L', 'l', 'DDMMYYYY'], true);
      if (momentDate.isValid()) {
        return momentDate.toDate();
      }
      return null;
    }
    return null;
  }

  public format(date: Date, displayFormat: Object): string {
    return momentLib(date).format('DD.MM.YYYY');
  }

  private _isDateOfLength8(value: string): boolean {
    const str = value.replace(' ', '');
    return (str && str.length === 8);
  }
}
